import Product from "./pages/Product";
import ProductList from "./pages/ProductList";
import Home from "./pages/Home";
import Register from "./pages/Register";
import Login from "./pages/Login";
import Cart from "./pages/Cart";
import {BrowserRouter,Route,Routes,Navigate, Outlet} from "react-router-dom"
import {Toaster,toast} from "react-hot-toast"
import CheckOutSuccess from "./PayPages/CheckOutSuccess";
import { useSelector } from "react-redux";
import { currentUserSelector } from "./redux/userRedux";
import User from "./pages/User";

function App() {

  const user = useSelector(currentUserSelector)
  // console.log({user});
  
  // const navigate=useNavigate()
  return (
    <BrowserRouter>
     <Toaster position='top-center' reverseOrder={false}>
        </Toaster>
      <Routes>
      <Route path={"/"} element={<Home/>}/>
      <Route path={"/register"} element={user?.toBeSent?<Home/>:<Register/>}/>
      <Route path={"/login"} element={user?.toBeSent?<Navigate to={"/"} />:<Login/>}/>
      <Route element={!user?.toBeSent?<Navigate to={"/login"} />:<Outlet/>}>
      <Route path={"/products/:category"} element={<ProductList/>}/>
      <Route path="/user" element={<User/>}/>
      <Route path={"/products"} element={<ProductList/>}/>
      <Route path={"/product/:id"} element={<Product/>}/>
      <Route path={"/cart"} element={<Cart/>}/>
      <Route path={"/checkout-success"} element={<CheckOutSuccess/>}/>
      </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
